import h from "trader-hyperscript";
import { LocalDate } from "@js-joda/core";
import { Form, constantField, selectBox } from "trader.ts/ui.forms";
import { periodid } from "../../../sql/classy/types";
import * as routes from "../../routes";
import { renderPeriod } from "../../translations_specific";
import {
  renderReportResult,
  runQueryOnFormChange,
} from "../finance_invoices/client";
import * as style from "../../../styles/style.css.classes";
import {
  downloadCsvFromTable,
  downloadXlsFromTable,
} from "../../client/downloadtable";
import { ddMMyyyy } from "../../render";

export function render(opts: {
  allPeriods: { firstday: LocalDate; lastday: LocalDate; id: periodid }[];
}): HTMLElement | HTMLElement[] {
  const periodsSorted = opts.allPeriods.orderBy(
    (p) => p.firstday.toEpochDay(),
    "desc",
  );

  const form = new Form({})
    .addField("period", [], () =>
      selectBox({
        values: periodsSorted,
        initial: periodsSorted[0],
        show: (p) => renderPeriod(p.firstday, p.lastday),
        label: "Schooljaar",
      }),
    )
    .addField("dummyForLayout", [], () =>
      constantField(null, { render: <span></span> }),
    )
    .build();

  const id = "classy-table-id";

  const res = runQueryOnFormChange(
    form.s,
    routes.loadEnrollmentStatisticsSpec,
    ({ period }) => ({ period }),
  );

  return (
    <div>
      <section
        className={style.cancel_main_margins}
        style="background-color: var(--grey-200); padding-bottom: 32px;"
      >
        {"Deze statistiek toont je hoeveel actieve inschrijvingen er elke week zijn/waren. Dit is niet relevant als je enkel inschrijvingen hebt voor een schooljaar, maar wel als je inschrijvingen hebt van een aantal weken."}
      </section>

      <section
        className={style.cancel_main_margins + style.equal_columns}
        style="margin-top: -32px;"
      >
        {form.render()}
      </section>

      <section>
        <div style="text-align: right;">
          <div style="font-size: 0.85em;">
            <a
              style="margin-right: 8px;"
              onclick={() =>
                downloadXlsFromTable("InschrijvingsStatistiek", id)
              }
            >
              {"Download als xls"}
            </a>
            <a
              onclick={() =>
                downloadCsvFromTable("InschrijvingsStatistiek", id)
              }
            >
              {"Download als csv"}
            </a>
          </div>
        </div>
        {renderReportResult(res, (rows, _query) => {
          return (
            <table id={id}>
              <tr>
                <th>{"Week"}</th>
                <th>{"Aantal actieve inschrijvingen"}</th>
                <th>{"Aantal actieve studenten"}</th>
              </tr>
              {rows.map((row) => (
                <tr>
                  <td>{row.monday.format(ddMMyyyy)}</td>
                  <td>{row.count.toString()}</td>
                  <td>{row.studentCount.toString()}</td>
                </tr>
              ))}
            </table>
          );
        })}
      </section>
    </div>
  );
}
